export const stripEmpty = (o) => Object.entries(o).reduce((accum, [key, val]) => {

  if (val && typeof val === 'object' && Object.prototype === Object.getPrototypeOf(val)) {
    accum[key] = stripEmpty(val);
  } else if (Array.isArray(val)) {
    accum[key] = val.map((v) => stripEmpty(v));
  } else if (val || val === false) {
    accum[key] = val;
  }
  return accum;
}, {});

export const replaceUndefined = (obj) => {
  if (obj === null || typeof obj === 'undefined') {
    return '';
  }
  if (obj && Array.isArray(obj)) {
    return obj.map((o) => replaceUndefined(o));
  }
  if (obj && typeof obj === 'object' && Object.prototype === Object.getPrototypeOf(obj)) {
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, replaceUndefined(v)]));
  }
  return obj;
};

export const mapValues = (o) => Object.entries(o).reduce((accum, [key, value]) => {
  let mappedVal;
  if (Array.isArray(value)) {
    mappedVal = value.map((v) => mapValues(v));
  } else if (value?.value) {
    mappedVal = value.value;
  } else if (value && typeof value === 'object' && Object.prototype === Object.getPrototypeOf(value)) {
    mappedVal = mapValues(value);
  } else {
    mappedVal = value;
  }
  accum[key] = mappedVal;
  return accum;
}, {});

export const isDeepEqual = (a, b) => {
  if (a === b) {
    return true;
  }

  if (a === null || b === null) {
    return false;
  }

  if (typeof a !== 'object' || typeof b !== 'object') {
    return false;
  }

  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    return areArraysEqual(a, b);
  }

  return areObjectsEqual(a, b);
};

const areArraysEqual = (arrA, arrB) => {
  if (arrA.length !== arrB.length) {
    return false;
  }

  for (let i = 0; i < arrA.length; i++) {
    if (!isDeepEqual(arrA[i], arrB[i])) {
      return false;
    }
  }

  return true;
};

const areObjectsEqual = (objA, objB) => {
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (const key of keysA) {
    if (!Object.prototype.hasOwnProperty.call(objB, key)) {
      return false;
    }

    if (!isDeepEqual(objA[key], objB[key])) {
      return false;
    }
  }

  return true;
};
